export enum NavigationPath {
  KIT_RETURN = '/kit_return',
  PAYMENT_DETAILS = '/payment_details',
  HOME = '/home',
  TEMPUS_PRO = '/pro',
  REPORT = '/report',
  DOCUMENTS = '/documents',
  DOCUMENT_DETAIL = '/documents/:id',
  LOGOUT = '/logout',
  TERMS_OF_USE = '/terms_of_use',
  REVIEW_PATIENT_INFO = '/review_patient_info',
  ONBOARDING = '/onboarding',

  FORGOT_PASSWORD = '/forgot_password',
  LANDING = '/',
}

export enum AuthenticationState {
  AUTH0_AUTHENTICATED = 'AUTH0_AUTHENTICATED',
  AUTH0_UNAUTHENTICATED = 'AUTH0_UNAUTHENTICATED',
}

export const DEFAULT_AUTH0_REDIRECT_PATH = NavigationPath.HOME;
